module.exports = __webpack_public_path__ + "img/email.a0606a9c.png";